import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { GridDataFreshnessService } from './grid-data-freshness.service';

/**
 * Marca a hora da última escrita bem-sucedida para o advanced-grid saber que os caches
 * gravados antes dela ficaram obsoletos. Ver GridDataFreshnessService.
 */
@Injectable()
export class GridWriteTrackingInterceptor implements HttpInterceptor {
  private readonly freshness = inject(GridDataFreshnessService);

  private static readonly WRITE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

  /**
   * Escritas que não alteram dados de listagem. Marcar por causa delas geraria refetch
   * inútil em todas as grids — no login, por exemplo, ou a cada filtro que o usuário salva.
   */
  private static readonly IGNORED_URLS = [
    /\/saved-filters\b/,
    /\/auth\b/,
    /\/login\b/,
    /\/logout\b/,
    /\/refresh(-token)?\b/,
    /\/password\b/,
  ];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isWrite = GridWriteTrackingInterceptor.WRITE_METHODS.has(req.method.toUpperCase());
    const isIgnored = GridWriteTrackingInterceptor.IGNORED_URLS.some(pattern =>
      pattern.test(req.url)
    );

    if (!isWrite || isIgnored) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse && event.status >= 200 && event.status < 300) {
          this.freshness.markWrite();
        }
      })
    );
  }
}
